@if (SteamTrapStatusCurrentTelemetry) {
  <div class="sensordata-wrapper">
    <app-sensor-value
      [telemetry]="SteamTrapStatusCurrentTelemetry"
      [asHeader]="true"
      [isSteamTrap]="true"
    >
    </app-sensor-value>
    <div class="grapharea-wrapper">
      <app-tab-bar
        [opaque]="true"
        [icon]="false"
        (tabChanged)="onTelemetryTimeframeSelect($event, Telemetry)"
        [disabled]="
          noDataTelemetry(Telemetry) ||
          graphBrushActive ||
          getTimeframe(Telemetry).custom
        "
      >
        <app-tab-bar-item
          class="one-of-three"
          [inactive]="isTelemetryTimeframeCustom"
        >
          {{ i18n.langString("days") }}</app-tab-bar-item
        >
        <app-tab-bar-item
          class="one-of-three"
          [inactive]="isTelemetryTimeframeCustom"
        >
          {{ i18n.langString("weeks") }}</app-tab-bar-item
        >
        <app-tab-bar-item
          class="one-of-three"
          [inactive]="isTelemetryTimeframeCustom"
        >
          {{ i18n.langString("months") }}</app-tab-bar-item
        >
      </app-tab-bar>
      @if (!graphDisplays.length) {
        <ng-container>
          <div class="graph-wrapper">
            <app-spinner [black]="true"></app-spinner>
          </div>
        </ng-container>
      }

      @if (graphDisplays.length > 0 && !!graphDisplays[0].graphData) {
        <ng-container>
          @if (graphDisplays[0].graphData[0].openRangePicker > 0) {
            <div
              class="range-picker-backdrop"
              (click)="cancelRangePick(graphDisplays[0].graphData[0])"
            ></div>
          }

          <div
            class="range-picker-wrapper"
            [class.disabled]="noDataTelemetry(Telemetry)"
          >
            @if (isDesktop || mobileDatePicker) {
              <ng-container>
                <nz-range-picker
                  [nzShowToday]="false"
                  [nzAllowClear]="false"
                  [nzPlaceHolder]="[
                    i18n.langString('start'),
                    i18n.langString('end'),
                  ]"
                  [nzDisabledDate]="
                    rangePickerDisabledDate(graphDisplays[0].graphData[0], 1)
                  "
                  #datePick
                  [(ngModel)]="range"
                  [id]="
                    'picker_start_' +
                    graphDisplays[0].graphData[0].metadata.measurementTypeID
                  "
                  (ngModelChange)="
                    onRangePickerSelect($event, graphDisplays[0].graphData[0])
                  "
                >
                </nz-range-picker>
              </ng-container>
            }
            <ng-template #mobileDatePicker>
              <nz-date-picker
                [nzShowToday]="false"
                [nzAllowClear]="false"
                #datePick
                [id]="
                  'picker_start_' +
                  graphDisplays[0].graphData[0].metadata.measurementTypeID
                "
                [nzDisabledDate]="
                  rangePickerDisabledDate(graphDisplays[0].graphData[0], 1)
                "
                [(ngModel)]="range[0]"
                (ngModelChange)="
                  onRangeStartPick(
                    graphDisplays[0].graphData[0].metadata.measurementTypeID,
                    graphDisplays[0].currentTelemetry.sensor.sensorID,
                    $event,
                    'picker_end_' +
                      graphDisplays[0].graphData[0].metadata.measurementTypeID,
                    graphDisplays[0].graphData[0]
                  )
                "
              >
              </nz-date-picker>
              <nz-date-picker
                [nzShowToday]="false"
                [nzAllowClear]="false"
                #datePick
                [id]="
                  'picker_end_' +
                  graphDisplays[0].graphData[0].metadata.measurementTypeID
                "
                [nzDisabledDate]="
                  rangePickerDisabledDate(graphDisplays[0].graphData[0], 2)
                "
                [(ngModel)]="range[1]"
                (ngModelChange)="
                  onRangeEndPick(
                    graphDisplays[0].graphData[0].metadata.measurementTypeID,
                    graphDisplays[0].currentTelemetry.sensor.sensorID,
                    $event,
                    graphDisplays[0].graphData[0]
                  )
                "
              >
              </nz-date-picker>
              <button>
                <span
                  [class.active]="
                    graphDisplays[0].graphData[0].openRangePicker === 1
                  "
                  (click)="
                    openRangePicker(
                      'picker_start_' +
                        graphDisplays[0].graphData[0].metadata
                          .measurementTypeID,
                      graphDisplays[0].graphData[0]
                    )
                  "
                  >{{ range[0] | date: DateFormat }}</span
                >
                -
                <span
                  [class.active]="
                    graphDisplays[0].graphData[0].openRangePicker === 2
                  "
                  (click)="
                    openRangePicker(
                      'picker_end_' +
                        graphDisplays[0].graphData[0].metadata
                          .measurementTypeID,
                      graphDisplays[0].graphData[0]
                    )
                  "
                  >{{ range[1] | date: DateFormat }}</span
                >
                <i
                  nz-icon
                  nzType="icons:edit"
                  class="sensor-icon svg-icon"
                  [class.fillgrey]="noData(graphDisplays[0].graphData[0])"
                  (click)="
                    openRangePicker(
                      'picker_start_' +
                        graphDisplays[0].graphData[0].metadata
                          .measurementTypeID,
                      graphDisplays[0].graphData[0]
                    )
                  "
                ></i>
              </button>
            </ng-template>
          </div>
        </ng-container>
      }

      @for (display of SteamTrapHealth; track $index) {
        <ng-container>
          @if (!display.loading) {
            <ng-container>
              @for (data of display.graphData; track $index) {
                <ng-container>
                  <div class="temp-spacer"></div>
                  <span class="analytics-header">{{
                    i18n.langString("steam_trap_states")
                  }}</span>
                  <div
                    class="steam-trap-state-legend"
                    [class.mobile]="isMobile"
                    [class.tablet]="isTablet"
                  >
                    <div class="green"></div>
                    <span>{{ i18n.langString("steam_trap_working") }}</span>
                    <div class="yellow"></div>
                    <span>{{
                      i18n.langString("steam_trap_blow_through")
                    }}</span>
                    <div class="red"></div>
                    <span>{{ i18n.langString("steam_trap_blocked") }}</span>
                  </div>
                  <div class="graph-wrapper">
                    @if (!data || !!data.loading) {
                      <app-spinner [black]="true"></app-spinner>
                    }

                    @if (!data.error) {
                      <app-graph
                        [Data]="data"
                        [class.hidden]="!!data.loading"
                        Type="pie"
                        [Timeframe]="getTimeframe(Telemetry)"
                        [Settings]="settings"
                        (brushStateChange)="graphBrushActive = $event"
                        (timeframeUpdated)="onDateRangeUpdatedfromGraph($event)"
                        [hasResetButton]="false"
                      >
                      </app-graph>
                    }
                    @if (!data.loading && !!data.error) {
                      <span class="error">{{
                        i18n.langString("error_loading_data")
                      }}</span>
                    }
                  </div>
                  <span class="analytics-header monitor">{{
                    i18n.langString("steam_trap_health")
                  }}</span>
                  <div class="graph-wrapper">
                    @if (!data || !!data.loading) {
                      <app-spinner [black]="true"></app-spinner>
                    }
                    @if (!data.error) {
                      <app-graph
                        [Data]="data"
                        [class.hidden]="!!data.loading"
                        Type="gantt"
                        [Timeframe]="getTimeframe(Telemetry)"
                        [Settings]="settings"
                        (brushStateChange)="graphBrushActive = $event"
                        (timeframeUpdated)="onDateRangeUpdatedfromGraph($event)"
                        [hasResetButton]="false"
                      >
                      </app-graph>
                    }

                    @if (!data.loading && !!data.error) {
                      <span class="error">{{
                        i18n.langString("error_loading_data")
                      }}</span>
                    }
                  </div>
                </ng-container>
              }
            </ng-container>
          }
        </ng-container>
      }
      @if (SteamTrapLoss && SteamTrapLoss.length > 0) {
        <ng-container>
          <span class="analytics-header steam-loss">{{
            this.i18n.langString("steam_loss_overview")
          }}</span>
          <span class="analytics-content small-text">{{
            OverviewContent
          }}</span>
          <div class="steam-loss-tab-selection">
            @if (HasSteamTrapLossMass) {
              <app-tab-bar
                [opaque]="true"
                [icon]="true"
                [disabled]="false"
                (tabChanged)="onTabChanged($event)"
              >
                <app-tab-bar-item [inactive]="false" class="one-of-three">
                  <div class="steam-loss-tab-header small-text">
                    {{ i18n.langString("steam_loss") }}
                  </div>
                  <div>{{ steamLossCurrencyUnit }}</div></app-tab-bar-item
                >
                <app-tab-bar-item [inactive]="false" class="one-of-three"
                  ><div class="steam-loss-tab-header small-text">
                    {{ i18n.langString("steam_loss") }}
                  </div>
                  <div>{{ steamLossMassUnit }}</div>
                </app-tab-bar-item>
                <app-tab-bar-item [inactive]="false" class="one-of-three"
                  ><div class="steam-loss-tab-header small-text">
                    {{ i18n.langString("co2_emission") }}
                  </div>
                  <div>{{ steamLossCo2Unit }}</div>
                </app-tab-bar-item>
              </app-tab-bar>
            }
          </div>
          <div class="steam-loss-info-wrapper">
            @if (
              (!HasSteamLossCurrencyUnit || showPricePerTonError) &&
              displayViz === DISPLAY_STEAM_TRAP_LOSS_AMOUNT
            ) {
              <div class="steam-loss-card error-card">
                <span class="error-message">
                  <i
                    nz-icon
                    [nzType]="'icons:status-exclamation-triangle'"
                    class="svg-icon fillwhite"
                  ></i>

                  <span class="text-bold">{{
                    i18n.langString("no_steam_price_error")
                  }}</span>
                </span>
                <span class="label"
                  >{{ range[0] | date: DateFormat }} -
                  {{ range[1] | date: DateFormat }}</span
                >
              </div>
            }
            @if (
              HasSteamLossCurrencyUnit ||
              displayViz !== DISPLAY_STEAM_TRAP_LOSS_AMOUNT
            ) {
              <div class="steam-loss-card">
                @if (
                  HasSteamTrapLossAmount &&
                  displayViz === DISPLAY_STEAM_TRAP_LOSS_AMOUNT
                ) {
                  <span class="value"
                    >{{ steamTrapLossAmountSum }}
                    {{ steamLossCurrencyUnit }}</span
                  >
                }
                @if (
                  HasSteamTrapLossMass &&
                  displayViz === DISPLAY_STEAM_TRAP_LOSS_MASS
                ) {
                  <span class="value">{{
                    formatValueAndUnit(steamTrapLossMassSum, steamLossMassUnit)
                  }}</span>
                }
                @if (
                  HasSteamTrapLossMass &&
                  displayViz === DISPLAY_STEAM_TRAP_LOSS_CO2
                ) {
                  <span class="value">{{
                    formatValueAndUnit(steamTrapLossCo2Sum, steamLossCo2Unit)
                  }}</span>
                }
                <span class="label"
                  >{{ range[0] | date: DateFormat }} -
                  {{ range[1] | date: DateFormat }}</span
                >
              </div>
            }
          </div>
          @for (display of SteamTrapLoss; track $index) {
            <ng-container>
              @if (!display.loading) {
                <ng-container>
                  @for (data of display.graphData; track $index) {
                    <ng-container>
                      <div class="graph-wrapper steam-loss">
                        @if (!data || !!data.loading) {
                          <app-spinner [black]="true"></app-spinner>
                        }

                        @if (!data.error) {
                          <app-graph
                            [Data]="data"
                            [class.hidden]="!!data.loading"
                            Type="bars"
                            [Timeframe]="getTimeframe(Telemetry)"
                            [Settings]="settings"
                            (brushStateChange)="graphBrushActive = $event"
                            (timeframeUpdated)="
                              onDateRangeUpdatedfromGraph($event)
                            "
                            (timeframeReset)="resetTimeframeSelect(Telemetry)"
                            [displayResetBtn]="graphBrushActive"
                            [hasResetButton]="true"
                          >
                          </app-graph>
                        }
                        @if (!data.loading && !!data.error) {
                          <span class="error">{{
                            i18n.langString("error_loading_data")
                          }}</span>
                        }
                      </div>
                    </ng-container>
                  }
                </ng-container>
              }
            </ng-container>
          }

          @if (showPrediction()) {
            <div class="steam-loss-prediction-wrapper">
              <span class="analytics-header steam-loss">{{
                i18n.langString("steam_loss_prediction")
              }}</span>
              <span class="analytics-content small-text">{{
                i18n.langString("steam_loss_prediction_content")
              }}</span>
              <div class="steam-loss-info-wrapper">
                <div class="steam-loss-card">
                  @if (displayViz === DISPLAY_STEAM_TRAP_LOSS_AMOUNT) {
                    <span class="value"
                      >{{
                        HasSteamTrapLossAmount
                          ? steamTrapLossAmount1Week
                          : "---"
                      }}
                      {{ steamLossCurrencyUnit }}</span
                    >
                  }

                  @if (
                    HasSteamTrapLossMass &&
                    displayViz === DISPLAY_STEAM_TRAP_LOSS_MASS
                  ) {
                    <span class="value">{{
                      formatValueAndUnit(
                        steamTrapLossMass1Week,
                        steamLossMassUnit
                      )
                    }}</span>
                  }

                  <span class="label"
                    >{{ i18n.langString("in_the_next") }}
                    <span class="text-bold">{{
                      i18n.langString("week_1")
                    }}</span>
                  </span>
                </div>
                <div class="steam-loss-card">
                  @if (displayViz === DISPLAY_STEAM_TRAP_LOSS_AMOUNT) {
                    <span class="value"
                      >{{
                        HasSteamTrapLossAmount
                          ? steamTrapLossAmount1Month
                          : "---"
                      }}
                      {{ steamLossCurrencyUnit }}</span
                    >
                  }

                  @if (
                    HasSteamTrapLossMass &&
                    displayViz === DISPLAY_STEAM_TRAP_LOSS_MASS
                  ) {
                    <span class="value">{{
                      formatValueAndUnit(
                        steamTrapLossMass1Month,
                        steamLossMassUnit
                      )
                    }}</span>
                  }

                  <span class="label"
                    >{{ i18n.langString("in_the_next") }}
                    <span class="text-bold">{{
                      i18n.langString("month_1")
                    }}</span>
                  </span>
                </div>
                <div class="steam-loss-card">
                  @if (displayViz === DISPLAY_STEAM_TRAP_LOSS_AMOUNT) {
                    <span class="value"
                      >{{
                        HasSteamTrapLossAmount
                          ? steamTrapLossAmount3Months
                          : "---"
                      }}
                      {{ steamLossCurrencyUnit }}</span
                    >
                  }

                  @if (
                    HasSteamTrapLossMass &&
                    displayViz === DISPLAY_STEAM_TRAP_LOSS_MASS
                  ) {
                    <span class="value">{{
                      formatValueAndUnit(
                        steamTrapLossMass3Months,
                        steamLossMassUnit
                      )
                    }}</span>
                  }

                  <span class="label"
                    >{{ i18n.langString("in_the_next") }}
                    <span class="text-bold">{{
                      i18n.langString("months_3")
                    }}</span>
                  </span>
                </div>
              </div>
            </div>
          }
        </ng-container>
      }
    </div>
  </div>
}
